import React from 'react';
import {Form, Input, Select, Row, Col, message, Tree} from 'antd';
import ModalDom from '../../../../components/Modal';
import { post, postFrom, config } from '../../../../axios';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { dicEmployeeStatus } from '../../../../axios/dictionaries';
import DetailTitle from "../../../../components/DetailTitle";

const Option = Select.Option;
const { TreeNode } = Tree;
class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            data: {},
            title: '新增部门',
            id: '',
            inputWidth: 260,
            jurisdictionData: [], //数据权限
            checkedKeys: [], //选中的房源
            employeeList: [] // 下拉人
        }
    }

    render() {
        let { visible, form: { getFieldDecorator } } = this.props;
        let { loading, data, title, inputWidth, employeeList,    jurisdictionData,   checkedKeys, } = this.state;

        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            width={"800px"}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
               >
            <div className="custom" >
            <Form
                labelCol={{ span: 0 }}
                wrapperCol={{ span: 24 }}
                className="min-height"
            >
                <Row>
                    <Col span={23} offset={1} >
                        <CustomRow>
                            <CustomCol  label="部门名称">
                                    {getFieldDecorator('name', {
                                        rules: [{
                                            required: true, message: '请输入部门名称',
                                        }],
                                        initialValue: data.name
                                    })(
                                        <Input 
                                             placeholder={'请输入'}
                                             
                                            autoComplete={'off'}
                                        />
                                    )}
                            </CustomCol>
                        </CustomRow>

                        <CustomRow divider>
                            <CustomCol  label="部门负责人">
                                    {getFieldDecorator('departmentHead', {
                                        initialValue: data.departmentHead
                                    })(
                                      <Select
                                      showSearch
                                        placeholder="请选择"
                                        optionFilterProp={'children'}
                                      >
                                        {employeeList.map((item, index) => <Option key={ index } value={ item.value }>{ item.title }</Option>)}
                                      </Select>
                                    )}
                            </CustomCol>
                        </CustomRow>

                        <CustomRow divider>
                            <CustomCol  label="使用状态">
                                    {getFieldDecorator('status', {
                                        rules: [{
                                            required: true, message: '请选择使用状态',
                                        }],
                                        initialValue: data.status || 1
                                    })(
                                        <Select
                                            showSearch
                                            
                                            placeholder="请选择"
                                            optionFilterProp={'children'}
                                        >
                                            {dicEmployeeStatus.map((item, index) => <Option key={ index } value={ item.value }>{ item.title }</Option>)}
                                        </Select>
                                    )}
                            </CustomCol>
                        </CustomRow>
                    </Col>
                </Row>
                <DetailTitle title="数据权限" />
                {
                    jurisdictionData.length
                        ? <Tree
                            // loadData={this.onLoadData}
                            multiple
                            checkable
                            onCheck={
                                (checkedKeys) => {
                                    this.setState({ checkedKeys });
                                }
                            }
                            checkedKeys={checkedKeys}
                            style={{
                                maxHeight: "200px",
                                overflowY: "scroll"
                            }}
                        >
                            {this.renderTreeNodes(jurisdictionData)}
                        </Tree>
                        : <div style={{ textAlign: 'center' }}>暂无数据</div>
                }
            </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this)
        this.postFindEmployeeList()
    }

    handleCancel = () => {
        this.props.handleCancel();
        this.setState({data: {}, loading: false, title: "新增部门",jurisdictionData: [], checkedKeys: [],})
        this.defaultcheckedKeys = [];
    }
    defaultcheckedKeys = []
     
    loadPack = ({id}) => {
        this.setState({ loading: true, title: "编辑部门", id });
        let data = { departmentId: id };
        postFrom({
            url: config.API_department_getById,
            data,
        }).then(res => {
            let checkedKeys = [];
            if( res.departmentDataAuthority) {
                checkedKeys = res.departmentDataAuthority.map((item, index) => {
                    return `project${item.projectId},${item.merchantId}`;
                });
                this.defaultcheckedKeys = res.departmentDataAuthority; //当前已被选中的项目
            }
            this.setState({ data: res, loading: false, checkedKeys });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        })
    }

    initPack(){
        postFrom({
            url: config.API_employeedataauthority_findMerchantAndProject,
            data: {}
        }).then(res => {
            let arr = [];
            arr = res.merchants.map((item, index) => {
                item.idDispose = 'merchant' + item.id;
                item.title = item.shortName;
                item.children = res.projects.filter((item2, index) => {
                    item2.idDispose = `project${item2.id},${item2.merchantId}`;
                    item2.title = item2.name;
                    return item.id === item2.merchantId
                })
                if(item.children.length === 0){
                    item.disabled = true
                }
                return item
            })

            this.setState({ jurisdictionData: arr, loading: false });
        }).catch(err => {
            message.error(err.message || '获取商户项目列表失败');
            this.setState({ loading: false });
        });
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {

            if(!error) {
                this.setState({loading: true});
                let data = {},
                NOW_URL = '',
                responText = '',
                { checkedKeys } = this.state;
                let departmentDataAuthority = [];
                for (let i = 0; i < checkedKeys.length; i++) {
                    if (checkedKeys[i].startsWith('project')) {
                        let checkHandle = checkedKeys[i].slice(7).split(',');
                        departmentDataAuthority.push({ merchantId: checkHandle[1], projectId: checkHandle[0] })
                    }
                }
                for (let i = 0; i < departmentDataAuthority.length; i++) {
                    let item = this.defaultcheckedKeys.find((item, index) => {
                        return item.projectId === +departmentDataAuthority[i].projectId
                    })
                    if (item) {
                        departmentDataAuthority[i].id = item.id;
                    }
                }

                values.departmentDataAuthority = departmentDataAuthority;


                data = Object.assign({}, values);

                if(this.props.handlecreateOrEdit){
                    NOW_URL = config.API_department_edit;
                    responText = '编辑';
                    data.id = this.state.id;
                } else {
                    NOW_URL = config.API_department_create;
                    responText = '新增';
                }  

                post({
                    url: NOW_URL, 
                    data,
                }).then(res => {
                    this.setState({loading: false});
                    this.props.handleGetList();
                    this.handleCancel();
                    message.success(`${responText}成功`);
                }).catch(err => {
                    message.error(err.message || '接口异常');
                    this.setState({ loading: false });
                });
            }
        })
    }

    renderTreeNodes = data => {
        return data.map(item => {
            if (item.children) {
                return (
                    <TreeNode disableCheckbox={item.disabled} selectable={false} title={item.title} key={item.idDispose} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode selectable={false} title={item.title} key={item.idDispose} dataRef={item} isLeaf={item.isChild} />;
        })
    }

    postFindEmployeeList() {
      this.setState({loading: true});
      postFrom({
        url: config.API_employee_findEmployeeList
      }).then(res => {
        const employeeList = []
        res.forEach(item => {
          employeeList.push({
            title: item.name,
            value: item.id
          })
        })
        this.setState({ loading: false, employeeList });
      }).catch(err => {
        message.error(err.message || '接口异常')
        this.setState({loading: false});
      })
    }
}

export default Form.create()(Page);


// WEBPACK FOOTER //
// ./src/page/Employee/components/DepartmentAdd/index.js